import {coinToss} from '../../helpers/numbers-helper.js'

/** Take in a list of attacks and return the one that would [probably] do the most damage */
export function getMostDamagingAttack(actionModels=[]) {

  //Filter for only offensive actions that are not
  const onlyAttacks = actionModels.filter(actionModel => {
    //First remove all items and supers (though, a Super would already have been chosen by now)
    return !actionModel.isItem && !actionModel.isSuper
  });

  const sortedByAttack = onlyAttacks.map(actionModel => {

    const repModel = actionModel.affectTargetHpPointsInRepetitions;
    if (repModel !== null && typeof repModel === "object" ) {
      const useValue = repModel.affectTargetHpPoints * (repModel.min); //Base off the lowest possibility
      return { id: actionModel.id, dmg: useValue }
    }

    //Special Case! Promise should be boosted, because it does not actually provide a bunch of damage up front
    if (actionModel.id === "special_promise" && coinToss()) {
      //MAYBE boost Promise based on Coin Toss (we don't want to always encourage Promise, it would be too often)
      return {
        id: actionModel.id, dmg: -12 //initial hit + big blast put together
      }
    }

    //Create sortable models with a damage value
    return {
      id: actionModel.id, dmg: actionModel.affectTargetHpPoints || 0
    }

  }).sort((a,b) => {
    //Sort the damage value: lower number = beginning of the list (because damage dealing values are negative)
    return a.dmg > b.dmg ? 1 : -1
  }).map(sortedModel => {
    return actionModels.find(m => m.id === sortedModel.id)
  });

  return sortedByAttack[0];
}


// WEBPACK FOOTER //
// ./src/battle/analysis/action-analysis-utilities.js